import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styleSheet"];
import React from 'react';
import { compose, setDisplayName } from 'recompose';
import omitProps from '@hocs/omit-props';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import Shape from '@bubble-ui/primitive-shape';
import Surface from '@bubble-ui/primitive-surface';

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var designVersion = _ref.designVersion;
  return {
    pathStyle: {
      fill: Colors.__iconError(designVersion).toString()
    }
  };
};

var Error = function Error(_ref2) {
  var pathStyle = _ref2.styleSheet.pathStyle,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Surface, _extends({
    height: 20,
    width: 20
  }, props), /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M10,17 C6.14011765,17 3,13.8598824 3,10 C3,6.14011765 6.14011765,3 10,3 C13.8598824,3 17,6.14011765 17,10 C17,13.8598824 13.8598824,17 10,17 Z M9,10.5 L11,10.5 L11,5.5 L9,5.5 L9,10.5 Z M10,11.5 C9.172,11.5 8.5,12.172 8.5,13 C8.5,13.828 9.172,14.5 10,14.5 C10.828,14.5 11.5,13.828 11.5,13 C11.5,12.172 10.828,11.5 10,11.5 Z"
  }, pathStyle)));
};

export default compose(setDisplayName('FeedbackStateIconError'), withDesignVersion, wrapOverridableComponent('FeedbackStateIconError', getDefaultStyleSheet), omitProps('color', 'designVersion'))(Error);
//# sourceMappingURL=index.js.map